// extracted by mini-css-extract-plugin
export default {"rating":"Jz-z","numberOfStars":"Kz-z","count":"Lz-z","barGraphSpacing":"Mz-z","barGraph":"Nz-z"};